module.exports = __webpack_public_path__ + "static/media/tasklist_1579099240543.2c90790b.png";